import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";

import { getCookie, userSessionExpired } from "./auth";
const User = () => {
  const history = useHistory();
  const deleteUser = (Id) => {
    return fetch(`${API}/delete-user/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewUsers = () => {
    return fetch(`${API}/get-all-users`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((err) => err);
  };
  const totalUsers = () => {
    return fetch(`${API}/total-users`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((err) => err);
  };
  const viewStaffs = () => {
    return fetch(`${API}/staffs`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => response.json())
      .catch((err) => err);
  };

  const deleteStaff = (Id) => {
    return fetch(`${API}/staff/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => response.json())
      .catch((err) => err);
  };

  const updateRole = (staffId, roleId) => {
    return fetch(`${API}/staff/update-role`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify({ staffId, roleId }),
    })
      .then((response) => response.json())
      .catch((err) => err);
  };

  const createStaff = (staffData) => {
    return fetch(`${API}/admin-signup`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(staffData),
    })
      .then((response) => response.json())
      .catch((err) => err);
  };

  return { deleteUser, viewUsers, totalUsers, viewStaffs, deleteStaff, updateRole, createStaff };
};

export default User;
